import { createGlobalStyle } from "styled-components";
import { root } from "./styles.root";

export const GlobalStyle = createGlobalStyle`
  ${root};
`;
